import { TitleScene } from "./TitleScene";
import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { PreloaderUIScene } from "./PreloaderUIScene";
import { assetDirectory } from "../../directory/AssetDirectory";
import { GameManager } from "../../managers/GameManager";

export class PreloaderScene extends Scene
{
    preloaderUIScene:PreloaderUIScene|null = null;

    preload(){
        this.preloaderUIScene = new PreloaderUIScene(this);

        let assetUrl = (<GameManager>GameManager.instance).assetUrl;

        //Load images
        for(let i =0; i< assetDirectory.images.length;i++)
        {
            this.load.image(assetDirectory.images[i].id, assetUrl+assetDirectory.images[i].src);
        }
        //Load Audio
        for(let i =0; i< assetDirectory.audio.length;i++)
        {
            this.load.audio(assetDirectory.audio[i].id, [assetUrl+assetDirectory.audio[i].mp3,assetUrl+assetDirectory.audio[i].ogg] ,{});
        }
    }

    prescaleCreate(){
        Button.buttonPressSfx = 'button_press';
        if(this.gameManager!.game!.device.os.iOS || this.gameManager!.game!.device.os.iPhone || this.gameManager!.game!.device.os.iPad){
            this.input.once('pointerdown',this.addNextScene,this);
        }else{
            this.addNextScene();
        }
    }

    addNextScene(){
        if(this.preloaderUIScene){
            this.preloaderUIScene.group.destroy(true);
            
        }
        this.scene.add('TitleScene', new TitleScene({key:'TitleScene'}),true);
    }
    
    reorient(landscape:boolean){
        if(this.preloaderUIScene){
            this.preloaderUIScene.reorient(landscape);
        }
    }
}